/* Just Brilliant: preserve server-rendered recommendations during lazy refresh. */
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.dataset.url) return;
      this.parent = this.closest('.product-recommendations--parent');
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.fetchProducts();
        }, {rootMargin: '600px'});
        this.observer.observe(this);
      } else this.fetchProducts();
    }
    async fetchProducts() {
      const controller = this.controller;
      if (!controller || this.fetching) return;
      this.fetching = true;
      let timeout;
      try {
        const text = await Promise.race([
          fetch(this.dataset.url, {signal: controller.signal}).then(response => {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          }),
          new Promise((_, reject) => {
            timeout = setTimeout(() => { controller.abort(); reject(new Error('Recommendations timed out')); }, 10000);
            this.requestTimeout = timeout;
          })
        ]);
        if (!this.isConnected || controller.signal.aborted || this.controller !== controller) return;
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) {
          this.innerHTML = recommendations.innerHTML;
          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');
            if (typeof OverlayManager !== 'undefined' && OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) this.parent.classList.add('active');
          }
        }
        this.classList.add('product-recommendations--loaded');
      } catch (error) {
        // Existing merchant/collection cards stay usable when the API cannot load.
        if (this.isConnected && this.controller === controller) this.classList.add('product-recommendations--fallback');
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) this.fetching = false;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      clearTimeout(this.requestTimeout);
      this.controller = null;
      this.fetching = false;
    }
  });
}
